function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImgWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236,
    height: 236,
    viewBox: "0 0 236 236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20519"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 4561",
    style: {
      fill: "#fff",
      stroke: "#e0e0df",
      strokeWidth: ".5px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 236,
    rx: 10,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 235.5,
    height: 235.5,
    rx: 9.75,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.25 24.75h-22v-22a2.75 2.75 0 0 0-5.5 0v22h-22a2.75 2.75 0 0 0 0 5.5h22v22a2.75 2.75 0 1 0 5.5 0v-22h22a2.75 2.75 0 1 0 0-5.5zm0 0",
    transform: "translate(90.095 90.095)",
    style: {
      fill: "#7c7c7c",
      stroke: "#7c7c7c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImgWhite);
export default __webpack_public_path__ + "static/media/upload-img-white.4ec47316286dcce525d5c5f70d97b25f.svg";
export { ForwardRef as ReactComponent };